import React, { useCallback, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfileAsync,
  makeProfile,
  updateIsCostIndexPresentation,
} from "@client.pages/Login/reducer";
import "./Settings.scss";
import SettingTabs from "./SettingTabs";
import {
  getNotificationSettingsAsync,
  makeNotificationSettings,
  updateNotificationSettingAsync,
} from "./reducer";
import { regenerateInsights } from "@client.pages/Dashboard/reducer";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import ActiveInsightsSection from "./ActiveInsightsSection";
import CalculationsSection from "./CalculationsSection";
import { useDemo } from "@client.hooks/useDemo";

const InsightsSettings = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const profile = useSelector(makeProfile);
  const filter = useSelector(makeFilter);
  const { isDemo, showDemoRestrictionModal } = useDemo();

  const notificationSettings = useSelector(makeNotificationSettings);

  const updateCostIndexPresentation = useCallback(
    (value) => {
      dispatch(
        updateIsCostIndexPresentation({ userId: profile.userId, value })
      );
    },
    [dispatch, profile]
  );

  useEffect(() => {
    if (!notificationSettings.data.length) {
      dispatch(getNotificationSettingsAsync(false));
    }

    return () => {
      dispatch(getProfileAsync());
    };
  }, [dispatch, notificationSettings.data.length]);

  useEffect(() => {
    setTopBarTitle(t("components.TopBar.settings"));
  }, [dispatch, setTopBarTitle, t]);

  const onSave = useCallback(
    async (setting) => {
      if (isDemo) {
        showDemoRestrictionModal();
        return;
      }
      await dispatch(updateNotificationSettingAsync(setting));
      dispatch(regenerateInsights(filter));
    },
    [dispatch, filter, isDemo, showDemoRestrictionModal]
  );

  const isNotificationDisabled = useCallback((notificationType) => {
    const notification = notificationSettings.data.find(
      (n) => n.type === notificationType
    );

    return !(notification && notification.isEnabled);
  }, [notificationSettings]);

  return (
    <div className="settings page">
      <SettingTabs />
      <div className="body insights-body">
        <ActiveInsightsSection 
          onSave={onSave}
          isNotificationDisabled={isNotificationDisabled}
        />
        <CalculationsSection
          isCostIndexPresentation={profile.isCostIndexPresentation}
          onUpdateCostIndexPresentation={updateCostIndexPresentation}
        />
      </div>
    </div>
  );
};

export default InsightsSettings;
